module.exports = __webpack_public_path__ + "images/emoji/grimacing.94ff5460a9086e9b8900.png";